module.exports = __webpack_public_path__ + "ai-evidence-demowp048b152d383948469818b9ad377a2497.gif";